import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NavigationService } from '../navigation.service';
import { AuthenticationService } from '../../authentication/authentication.service';
import { FhirService } from '../fhir.service';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor
{
    constructor(
        private router: Router,
        private navigationService: NavigationService,
        private authService: AuthenticationService,
        private fhirService: FhirService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const isFHIRAuth = request.url === '/authenticate' && this.fhirService.issuer !== null;

        return next.handle(request).pipe(
            tap({
                error: (err: any) =>
                {
                    if (err instanceof HttpErrorResponse)
                    {
                        const returnUrl = this.navigationService.getReturnUrl() ? this.navigationService.getReturnUrl() : null;
                        switch (err.status)
                        {
                            case 401:
                                // If FHIR Authentication is not successful, do not redirect to login 
                                // We do not redirect flowable to login because in twofa context, user unable to enter their code (accounts might be out of synch).
                                if (!isFHIRAuth && !request.url.includes('flowable-idm/app/authentication'))
                                {
                                    this.router.navigate(['login'], returnUrl ? { queryParams: { return: returnUrl } } : {});
                                }
                                break;
                            case 404:
                                // If authenticated, redirect to not-found, otherwise redirect to login
                                this.router.navigate([this.authService.isAuthenticated ? 'not-found' : 'login']);
                                break;
                        }
                        return;
                    }
                }
            }));
    }
}

